import type { ReactElement } from "react";
import type { RouteObject } from "react-router";

import { NotFoundPage } from "../account/message-pages.js";

import { ContractorConfirmPage, ContractorPage } from "./contractor-pages.js";
import { RegisterPage } from "./register-page.js";
import { TenantScoped, type TenantScope } from "./tenant-scoped.js";
import { UserDeletePage } from "./user-delete-page.js";
import { UserEditPage } from "./user-edit-page.js";
import { UserListPage } from "./user-list-page.js";

/** 対象の利用者が要る画面。<b>URL の最後が無ければ「見つからない」</b>。 */
const withTarget = (page: (tenantId: number, id: string) => ReactElement) =>
    ({ tenantId, id }: TenantScope): ReactElement =>
        (id === undefined || id === "" ? <NotFoundPage /> : page(tenantId, id));

const base = "/tenant/Edit/:tenantId/TenantUser";

/**
 * 契約の中の利用者。<b>足したら paths/tenant-users.json にも足す。</b>
 *
 * <b>URL は今のアプリと同じ</b>（<c>/tenant/Edit/{契約}/TenantUser/{操作}/{対象}</c>）。
 * 招待メールのリンクは <c>/Tenant/…</c> と大文字で始まるが、React Router は大文字小文字を問わない。
 */
export const tenantUserRoutes: RouteObject[] = [
    {
        path: `${base}/Index`,
        element: <TenantScoped render={({ tenantId }) => <UserListPage tenantId={tenantId} />} />,
    },
    {
        path: `${base}/Edit/:id`,
        element: <TenantScoped render={withTarget((tenantId, id) => <UserEditPage tenantId={tenantId} id={id} />)} />,
    },
    {
        path: `${base}/Delete/:id`,
        element: <TenantScoped render={withTarget((tenantId, id) => <UserDeletePage tenantId={tenantId} id={id} />)} />,
    },
    {
        path: `${base}/Register`,
        element: <TenantScoped render={({ tenantId }) => <RegisterPage tenantId={tenantId} />} />,
    },
    {
        path: `${base}/Contractor`,
        element: <TenantScoped render={({ tenantId }) => <ContractorPage tenantId={tenantId} />} />,
    },
    {
        path: `${base}/ContractorConfirm/:id`,
        element: (
            <TenantScoped
                render={withTarget((tenantId, id) => <ContractorConfirmPage tenantId={tenantId} id={id} />)}
            />
        ),
    },
];
